import { render, staticRenderFns } from "./PostDemoGuide.vue?vue&type=template&id=48406781&"
import script from "./PostDemoGuide.vue?vue&type=script&lang=js&"
export * from "./PostDemoGuide.vue?vue&type=script&lang=js&"
import style0 from "./PostDemoGuide.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports